import React from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {
  Row,
  Col,
  Container,
 
} from "reactstrap";
import { Drawer } from "@material-ui/core";
import { useForm } from "react-hook-form";

const EmailTemplateView = (props) => {
  const emailTemplate = props?.open?.id;
  

const {

  reset,
  formState: {  },
} = useForm({ defaultValues: { IsActive: true }, mode: "onChange" });

const closebtn = () => {
  props.closeDrawer();
  reset();
};
  // return (
  //   
  // );
  return (
    <>
      <div className="bg-white hl-common-page">
        <Drawer
          // anchor={props.anchor}
          open={props.open}
          // onClose={(e) => toggleDrawer(e)}
          anchor={"right"}
        >
          <Container>
            <div className={"drawer-wrapper"}>
              <Row className="drawer-heading">
                <Col>
                  <div className={"header-wrapper left"}>
                    <h3>{"Email"}</h3>
                  </div>
                  <div onClick={closebtn} className={"close-button right"}></div>
                </Col>
              </Row>

              {!emailTemplate ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <div>Loading...</div>
                </div>
              ) : (
                <div>
                  <div className="email-template-container" dangerouslySetInnerHTML={{ __html: emailTemplate }}></div>
                </div>
              )}
            </div>
          </Container>
        </Drawer>
      </div>
    </>
  );
};

export default EmailTemplateView;